import { c as _c } from "react/compiler-runtime";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { ReserveCommentPopupScroll } from "@website/widget/reserve-comment-popup-scroll";
import { ReserveCommentPopupPropertiesTypes } from "@website/widget/reserve-comments-layout/reserve-comment-popup/reserve-comment-popup.types";
import { useRouter } from "next/router";
import { useEffect, useRef } from "react";
export const ReserveCommentPopup = t0 => {
  const $ = _c(25);
  const {
    hotelTitle,
    rate,
    comments,
    onClose,
    open,
    onLoadMore,
    isLoading,
    onLoadFilter,
    filters
  } = t0;
  const reference = useRef(null);
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      reference.current?.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = router?.query?.order_by;
  const t3 = router?.query?.filter_attitude;
  let t4;
  if ($[1] !== t2 || $[2] !== t3) {
    t4 = [t2, t3];
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  useEffect(t1, t4);
  let t5;
  if ($[4] !== onClose) {
    t5 = onClose.bind(null, false);
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== hotelTitle) {
    t6 = hotelTitle && <div className="text-body-2 text-on-surface-medium-emphasis px-6 pb-2 pt-9 lg:pt-1">{hotelTitle}</div>;
    $[6] = hotelTitle;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== comments || $[9] !== filters || $[10] !== isLoading || $[11] !== onLoadFilter || $[12] !== onLoadMore || $[13] !== rate) {
    t7 = <div className="overflow-y-scroll lg:h-[75vh]" ref={reference}><ReserveCommentPopupScroll comments={comments} filters={filters} isLoading={isLoading} onLoadFilter={onLoadFilter} onLoadMore={onLoadMore} rate={rate} /></div>;
    $[8] = comments;
    $[9] = filters;
    $[10] = isLoading;
    $[11] = onLoadFilter;
    $[12] = onLoadMore;
    $[13] = rate;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onClose) {
    t8 = <div className="hidden h-auto w-full bg-white px-6 pt-3 text-left lg:block"><Button onClick={onClose} variant="outline" color="neutral" className="text-left" text={"\u0628\u0633\u062A\u0646"} /></div>;
    $[15] = onClose;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
    t9 = <div className="relative justify-center bg-white lg:w-[900px]">{t6}{t7}{t8}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== open || $[22] !== t5 || $[23] !== t9) {
    t10 = <Modal className="z-40 overflow-y-auto !px-0 md:h-[919px]" onClose={t5} showCloseButton={true} open={open} title={"\u0646\u0638\u0631\u0627\u062A"} titleClassName="!text-subtitle-1" headerStyle="px-6 !h-[60px] lg:!h-auto fixed lg:static lg:pt-0 top-0 z-20 bg-white">{t9}</Modal>;
    $[21] = open;
    $[22] = t5;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
};